// action/auth/authSelectors.js
export const selectToken = (state) => state.auth.loginData;
